import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, FileSignature, ChevronRight } from "lucide-react";

/* 分包商库顶部提醒条：已发送未签署合同数 / 即将过期 / 已过期 → 合同签署跟进看板 */
export const SignFollowupBanner = ({ api, zh }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/subcontracts/sign-followup").then(({ data }) => setS(data.summary)).catch(() => setS(null)); }, [api]);
  if (!s || !s.total) return null;
  const urgent = s.expired + s.expiringSoon;
  return (
    <Link to="/sign-followup" data-testid="sign-followup-banner" data-total={s.total} data-expired={s.expired}
      className={`mb-3 flex items-center gap-2 rounded-xl border px-3 py-2 text-sm transition-colors ${urgent ? "border-red-300 bg-red-50 text-red-900 hover:bg-red-100" : "border-amber-300 bg-amber-50 text-amber-900 hover:bg-amber-100"}`}>
      {urgent ? <AlertTriangle className="h-4 w-4 shrink-0" /> : <FileSignature className="h-4 w-4 shrink-0" />}
      <span className="font-semibold">{zh ? `${s.total} 份分包合同已发送未签署` : `${s.total} subcontracts sent but unsigned`}</span>
      <span className="text-xs opacity-80">{zh ? `即将过期 ${s.expiringSoon} · 已过期 ${s.expired} · 已查看未签 ${s.viewedNotSigned}${s.mine ? ` · 我的项目 ${s.mine}` : ""}` : `expiring ${s.expiringSoon} · expired ${s.expired} · viewed ${s.viewedNotSigned}`}</span>
      <span className="ml-auto inline-flex items-center gap-0.5 text-xs font-semibold underline">{zh ? "打开签署跟进看板" : "Open follow-up board"}<ChevronRight className="h-3.5 w-3.5" /></span>
    </Link>
  );
};
